// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Tabs_tabsContainer__20oak"};